
  import { computed, defineComponent } from 'vue';
  import InlineSvg from 'vue-inline-svg';
  import { Colour } from '../../../helpers/colour';
  import { Icon } from '../../../helpers/icon';
  import './icon.scss';

  /**
    * Render inline SVG icons
    * 
    * @example
    * <code>import TpxIcon from '@manifesto-tech/tpximpact-design-system/components/atoms/icon/icon.vue'</code>
    */
  export default defineComponent({
    name: 'TpxIcon',

    components: {
      InlineSvg,
    },

    props: {
      /**
       * Display with a border?
       */
      borderColour: {
        type: String,
        validator: (value: Colour) => {
          return Object.values(Colour).includes(value);
        },
      },

      /**
        * Icon to be rendered
        */
      icon: {
        type: String,
        required: true,
        validator: (value: Icon) => {
          return Object.values(Icon).includes(value);
        },
      },

      /**
        * A meaningful description/label
        */
      label: {
        type: String,
        required: true,
      },

      /**
       * Double the icon size?
       */
      isLarge: {
        type: Boolean,
      },
    },

    data() {
      return {
        classes: computed(() => ({
          [`a-icon--${this.icon}`]: !!this.icon,
          ['a-icon--large']: this.isLarge,
          ['a-icon--has-border']: this.borderColour,
          [`border border--${this.borderColour}`]: this.borderColour,
        })),
      };
    },
  });
